/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAzureResourcePatchErrorDetails extends models.PatchManagementAzureErrorContext {
    getFixupPrototypeFunction() { return PatchManagementAzureResourcePatchErrorDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAzureResourcePatchErrorDetails>): PatchManagementAzureResourcePatchErrorDetails {
        let obj = Object.assign(new PatchManagementAzureResourcePatchErrorDetails(), model);
        PatchManagementAzureResourcePatchErrorDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAzureResourcePatchErrorDetails>): PatchManagementAzureResourcePatchErrorDetails {
        if (!model) return null;
        return PatchManagementAzureResourcePatchErrorDetails.newInstance(<PatchManagementAzureResourcePatchErrorDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAzureResourcePatchErrorDetails) {
        if (!obj) return;

        models.PatchManagementAzureResourcePatchErrorDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAzureResourcePatchErrorDetails): boolean {
        if (models.PatchManagementAzureErrorContext.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PatchManagementAzureResourcePatchErrorDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            for (let val of this.details) {
                models.PatchManagementAzureErrorContext.fixupPrototype(val);
            }
        }
    }

    /**
     * Error details
     */
    details: Array<models.PatchManagementAzureErrorContext>;

}
